var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "app-container",
    },
    [
      _c("div", { staticClass: "title" }, [_vm._v("支付记录")]),
      _vm._v(" "),
      _vm._l(_vm.list, function (item, index) {
        return _c(
          "el-descriptions",
          { key: index, attrs: { title: "", column: 1 } },
          [
            _c("el-descriptions-item", { attrs: { label: "支付流水号" } }, [
              _vm._v(_vm._s(item.payTradeNo)),
            ]),
            _vm._v(" "),
            _c("el-descriptions-item", { attrs: { label: "交易时间" } }, [
              _vm._v(_vm._s(item.payTime)),
            ]),
            _vm._v(" "),
            _c("el-descriptions-item", { attrs: { label: "交易金额" } }, [
              _vm._v(_vm._s(item.payAmount)),
            ]),
            _vm._v(" "),
            _c(
              "el-descriptions-item",
              { attrs: { label: "订单号 " } },
              [
                _c("el-tag", { attrs: { size: "small" } }, [
                  _vm._v(_vm._s(item.orderNo)),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-descriptions-item", { attrs: { label: "交易类型" } }, [
              _vm._v(" " + _vm._s(item.payType) + " "),
            ]),
            _vm._v(" "),
            _c("el-descriptions-item", { attrs: { label: "交易状态" } }, [
              _vm._v(" " + _vm._s(item.payStatus) + " "),
            ]),
            _vm._v(" "),
            _c("el-descriptions-item", { attrs: { label: "付款方信息" } }, [
              _vm._v(" " + _vm._s(item.payeeName) + " "),
            ]),
            _vm._v(" "),
            _c("el-descriptions-item", { attrs: { label: "收款方信息" } }, [
              _vm._v(" " + _vm._s(item.payerName) + " "),
            ]),
            _vm._v(" "),
            _c("el-descriptions-item", { attrs: { label: "支付方式" } }, [
              _vm._v(" " + _vm._s(item.payMethod) + " "),
            ]),
            _vm._v(" "),
            _c("el-descriptions-item", { attrs: { label: "币种" } }, [
              _vm._v(" " + _vm._s(item.currency) + " "),
            ]),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }